export default function () {
  const widgetName = 'multischedulefeature';
  const widgetOpts = multiScheduleFeatureOpts;

  $(`#${widgetName}`).append(
    '<div class="multiFeatureContent"> <span class="multi-title">Event Calendar</span></div>',
  );
  setTimeout(function () {
    $('.all-events-btn').wrap("<div class='events-btn-wrap'></div>");
  }, 2000);
  $(`#${widgetName}`).MultiScheduleFeature({
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID,
    detectIpad: IPADDETECTED,
    // options
    allEventsLink: true,
    allEventsLinkText: 'view full calendar',
    hasImages: false,
    imageBackground: false,
    lazyLoadImages: true,
    buyNowButton: { visible: false, text: '>' },
    moreButton: { visible: false, text: 'MORE' },
    maxItemsVisible: 4,
    isResponsive: false,
    hasDescription: false,
    textContainer: true,
    link: ['all'], //options are 'all', 'text', 'image', 'imageAndText', or ''
    attributeOrder: {
      1: 'image',
      2: 'title',
      3: 'date',
      4: 'description',
      5: 'buttons',
    },
    multiFeatureLoaded: function () {
      $('#multischedulefeature .featureItem').each(function () {
        // Reference to the current featureItem element
        let featureItem = $(this);
        let itemDescripton = featureItem.find('.featureItemDescription');
        let itemtittle = featureItem.find('.featureItemTitle');
        //uncomment below if you need to slice the date string up into something shorter like "Oct 31"
        let eventDate = $(this).find($('span.featureItemDate'));
        let datesMonth = eventDate.text().slice(0, 3);
        let datesDay = eventDate.text().slice(4, 7).replace('-', '').replace(',', '');
        eventDate.text(datesMonth);
        eventDate.append('<span>' + datesDay + '</span>');
        let characterLimitTitle = 25;
        let itemTitleText = itemtittle.text();
        if (itemTitleText.length > characterLimitTitle) {
          let trimmedTextTitle = itemTitleText.substring(0, characterLimitTitle);
          itemtittle.text(trimmedTextTitle);
        }

        // Limit character length of item description
        let characterLimitDescription = 35;
        let itemDescriptonText = itemDescripton.text();
        if (itemDescriptonText.length > characterLimitDescription) {
          let trimmedTextDescription =
            itemDescriptonText.substring(0, characterLimitDescription) + '...';
          itemDescripton.text(trimmedTextDescription);
        }
      });
    },
  });
}
